// Chip compacto para mostrar el aliado que trajo una venta/cliente.
// Color determinístico por hash del slug — cada aliado siempre del mismo color.
// Uso: <AliadoChip slug="biko" nombre="Biko Brazionis" />
// Si no hay slug/nombre: no renderiza nada (fila queda limpia, sin "directo" ni ruido).

const PALETA = [
  { bg: '#CFFAFE', fg: '#155E75', border: '#67E8F9' }, // cyan
  { bg: '#DBEAFE', fg: '#1E3A8A', border: '#93C5FD' }, // blue
  { bg: '#FCE7F3', fg: '#9D174D', border: '#F9A8D4' }, // pink
  { bg: '#FEF3C7', fg: '#78350F', border: '#FCD34D' }, // amber
  { bg: '#D1FAE5', fg: '#065F46', border: '#6EE7B7' }, // green
  { bg: '#E0E7FF', fg: '#3730A3', border: '#A5B4FC' }, // indigo
  { bg: '#FED7AA', fg: '#7C2D12', border: '#FDBA74' }, // orange
  { bg: '#F3E8FF', fg: '#581C87', border: '#D8B4FE' }, // purple
]

function hashSlug(s) {
  let h = 0
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0
  return Math.abs(h)
}

export default function AliadoChip({ slug, nombre, size = 'sm' }) {
  const s = (slug || '').toString().trim().toLowerCase()
  const n = (nombre || '').toString().trim()
  if (!s && !n) return null

  const key = s || n.toLowerCase()
  const c = PALETA[hashSlug(key) % PALETA.length]
  const label = s ? s.toUpperCase() : n.split(' ')[0]
  const title = n && s ? `Vino por ${n} (${s.toUpperCase()})`
              : n     ? `Vino por ${n}`
              :         `Vino por ${s.toUpperCase()}`

  const isMd = size === 'md'

  return (
    <span
      title={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: isMd ? '3px 9px' : '2px 7px',
        borderRadius: 999,
        fontSize: isMd ? 12 : 11,
        fontWeight: 600,
        background: c.bg,
        color: c.fg,
        border: `1px solid ${c.border}`,
        whiteSpace: 'nowrap',
        lineHeight: 1.3,
      }}
    >
      <span style={{ opacity: 0.6, fontWeight: 500 }}>via</span>
      {label}
    </span>
  )
}
